import { render, staticRenderFns } from "./businessHome.vue?vue&type=template&id=190c8b36&scoped=true"
import script from "./businessHome.vue?vue&type=script&lang=js"
export * from "./businessHome.vue?vue&type=script&lang=js"
import style0 from "./businessHome.vue?vue&type=style&index=0&id=190c8b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c8b36",
  null
  
)

export default component.exports